<!-- Translated: yes -->
<template>
  <div class="back" @click="click">
    <span class="text">
      <icon name="arrow" :scale="1.2"></icon>
      {{ text ? text : $t('general.back') }}
    </span>
  </div>
</template>

<script>
export default {
  props: ['clicked', 'text'],
  methods: {
    click() {
      if (this.clicked) {
        this.clicked();
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.back
  background-color: pale-grey
  cursor pointer
  width auto
  text-align left
  font-size 12px
  display inline-block
  +min-tablet()
    background-color: pale-grey
    border-radius: 3px
    padding: 0.75rem 1rem 0.875rem;
    width: auto
    display inline-block
  .icon
    position: relative
    top: -1px
    margin-right: 7px
  +max-mobile()
    background-color #ecf5f8
    font-size: 14px
    padding: 0.75rem 1rem 0.875rem;

  .text
    color deep-sea-blue
    font-size: 11px
    uppercase()
    font-weight 700
    +max-mobile()
      display block

</style>



// WEBPACK FOOTER //
// Back-v2.vue?75ee507b